import { shape, string, number, arrayOf, bool, element } from 'prop-types';

export const itemLoyalty = shape({
  id: number,
  productId: number,
  points: number,
  name: string,
  productName: string,
  pictures: arrayOf(
    shape({
      id: number,
      url: string
    })
  )
});

export const redeemsPropType = arrayOf(
  shape({
    id: number,
    createdAt: string,
    pointsSpent: number,
    name: string,
    variantName: string,
    pointsGained: number
  })
);

export const loyaltiesPropTypes = arrayOf(itemLoyalty);

const productBenefit = arrayOf(
  shape({
    category: string,
    description: string,
    freeExtras: number,
    id: number,
    isAlcohol: bool,
    name: string,
    unavailableForHalves: bool,
    unpermittedModifyCheese: bool,
    foodType: arrayOf(string)
  })
);

const loyaltyBenefits = arrayOf(
  shape({
    compId: number,
    description: string,
    discount: number,
    freeDeliveryDays: arrayOf(string),
    name: string,
    products: productBenefit
  })
);

export const levelLoyalty = shape({
  id: number,
  level: number,
  description: string,
  minPoints: string,
  loyaltyBenefits,
  name: string
});

export const levelsLoyaltyPropTypes = arrayOf(levelLoyalty);

export const loyaltyIconsPropTypes = shape({ icon: element, userIcon: string, badge: string });
